import * as accountSettings from 'core/api/accountSettings';
import * as activities from 'core/api/activities';
import * as alumni from 'core/api/alumni';
import * as analytics from 'core/api/analytics';
import * as appManager from 'core/api/appManager';
import * as assessments from 'core/api/assessments';
import * as badges from 'core/api/badges';
import * as careerInterest from 'core/api/careerInterest';
import * as careers from 'core/api/careers';
import * as checkins from 'core/api/checkins';
import * as clr from 'core/api/clr';
import * as collegeAppConfig from 'core/api/collegeAppConfig';
import * as collegeCost from 'core/api/collegeCost';
import * as common from 'core/api/common';
import * as configurationReport from 'core/api/configurationReport';
import * as counselorDashboard from 'core/api/counselorDashboard';
import * as cpConfig from 'core/api/cpConfig';
import * as cpCourses from 'core/api/cpCourses';
import * as cpGraduationPlans from 'core/api/cpGraduationPlans';
import * as cpPrograms from 'core/api/cpPrograms';
import * as cpRequirements from 'core/api/cpRequirements';
import * as cpStudentPlans from 'core/api/cpStudentPlans';
import * as ctePrograms from 'core/api/ctePrograms';
import * as dataIntegration from 'core/api/dataIntegration';
import * as documentCenter from 'core/api/documentCenter';
import * as efill from 'core/api/efill';
import * as elementaryCareers from 'core/api/elementaryCareers';
import * as eventScheduler from 'core/api/eventScheduler';
import * as experienceTracking from 'core/api/experienceTracking';
import * as externalData from 'core/api/externalData';
import * as fafsa from 'core/api/fafsa';
import * as finalList from 'core/api/finalList';
import * as goals from 'core/api/goals';
import * as guidedSetup from 'core/api/guidedSetup';
import * as higherEd from 'core/api/higherEd';
import * as historical from 'core/api/historical';
import * as ilp from 'core/api/ilp';
import * as indicators from 'core/api/indicators';
import * as industryPartnerCRM from 'core/api/industryPartnerCRM';
import * as ipProgramManagement from 'core/api/ipProgramManagement';
import * as k12Users from 'core/api/k12Users';
import * as keyReadinessIndicators from 'core/api/keyReadinessIndicators';
import * as learningChapters from 'core/api/learningChapters';
import * as lessonLibrary from 'core/api/lessonLibrary';
import * as lifeSimulator from 'core/api/lifeSimulator';
import * as miscellaneous from 'core/api/miscellaneous';
import * as notifications from 'core/api/notifications';
import * as objectMatch from 'core/api/objectMatch';
import * as onboardingAndLogin from 'core/api/onboardingAndLogin';
import * as opportunities from 'core/api/opportunities';
import * as organizations from 'core/api/organizations';
import * as orgProfile from 'core/api/orgProfile';
import * as reports from 'core/api/reports';
import * as roster from 'core/api/roster';
import * as scholarship from 'core/api/scholarship';
import * as schoolProfile from 'core/api/schoolProfile';
import * as seniorSurvey from 'core/api/seniorSurvey';
import * as skillsAssessment from 'core/api/skillsAssessment';
import * as slSchools from 'core/api/slSchools';
import * as slUsers from 'core/api/slUsers';
import * as smartGoals from 'core/api/smartGoals';
import * as studentProfile from 'core/api/studentProfile';
import * as surveys from 'core/api/surveys';
import * as swipe from 'core/api/swipe';
import * as testScores from 'core/api/testScores';
import * as thirdParty from 'core/api/thirdParty';
import * as transcripts from 'core/api/transcripts';
import * as transmissions from 'core/api/transmissions';
import * as videoQna from 'core/api/videoQna';
import * as virtualTours from 'core/api/virtualTours';
import * as wyr from 'core/api/wouldYouRather';

export default {
  accountSettings,
  activities,
  alumni,
  analytics,
  appManager,
  assessments,
  badges,
  careerInterest,
  careers,
  checkins,
  clr,
  collegeAppConfig,
  collegeCost,
  common,
  configurationReport,
  counselorDashboard,
  cpConfig,
  cpCourses,
  cpGraduationPlans,
  cpPrograms,
  cpRequirements,
  cpStudentPlans,
  ctePrograms,
  dataIntegration,
  documentCenter,
  efill,
  elementaryCareers,
  eventScheduler,
  experienceTracking,
  externalData,
  fafsa,
  finalList,
  goals,
  guidedSetup,
  higherEd,
  historical,
  ilp,
  indicators,
  industryPartnerCRM,
  ipProgramManagement,
  k12Users,
  keyReadinessIndicators,
  learningChapters,
  lessonLibrary,
  lifeSimulator,
  miscellaneous,
  notifications,
  objectMatch,
  onboardingAndLogin,
  opportunities,
  organizations,
  orgProfile,
  reports,
  roster,
  scholarship,
  schoolProfile,
  seniorSurvey,
  skillsAssessment,
  slSchools,
  slUsers,
  smartGoals,
  studentProfile,
  surveys,
  swipe,
  testScores,
  thirdParty,
  transcripts,
  transmissions,
  videoQna,
  wyr,
  virtualTours,
};
